import { FC, memo, SyntheticEvent, useEffect, useState } from 'react';
import classNames from 'classnames';

import { CheckboxPropTypes } from './index.type';

const Checkbox: FC<CheckboxPropTypes> = ({
  id,
  label,
  error,
  checked,
  onChange,
  className,
  ...props
}) => {
  const [isChecked, setChecked] = useState(false);

  const handleChange = (event: SyntheticEvent) => {
    const check = (event.target as HTMLInputElement).checked;

    if (onChange) onChange(check);

    setChecked(check);
  };

  useEffect(() => {
    if (typeof checked !== 'undefined') setChecked(checked);
  }, [checked]);

  return (
    <input
      {...props}
      type="checkbox"
      checked={isChecked}
      onChange={handleChange}
      className={classNames('checkbox', className, {
        VALIDATION_CLASS: !!error,
      })}
    />
  );
};

export default memo(Checkbox);
